import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiAppendToBodyDirective } from '../../directives/ui-append-to-body.directive';
import { UiSwipeDirective } from '../../directives/ui-swipe.directive';

@Component({
  selector: 'ui-bottom-sheet',
  standalone: true,
  imports: [CommonModule, UiAppendToBodyDirective, UiSwipeDirective],
  templateUrl: './ui-bottom-sheet.component.html',
  styleUrls: ['./ui-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBottomSheetComponent {
  public readonly open = input<boolean>(false);
  public readonly title = input<string>('');
  public readonly stableHeight = input<boolean>(false);
  public readonly sheetHeight = input<string | undefined>(undefined);

  public readonly closeEmit = output<void>();
}
